"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var api_1 = __importStar(require("api"));
var use_notification_1 = require("hooks/use-notification");
var TextInput_1 = __importDefault(require("../common/inputs/TextInput"));
var Button_1 = __importDefault(require("../common/buttons/Button"));
var Notification_1 = require("../Notification");
var ForgotPassword = function () {
    var _a = react_1.useState(''), emailAddress = _a[0], setEmailAddress = _a[1];
    var notification = use_notification_1.useNotification();
    react_1.useEffect(function () {
        document.title = "Forgot Password";
    }, []);
    var submitHandler = function (e) {
        e.preventDefault();
        if (emailAddress.length <= 0) {
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: 'Please enter your email address'
            });
            return;
        }
        api_1.default.forgotPassword({ emailAddress: emailAddress })
            .then(function () {
            notification({
                variant: Notification_1.NotificationVariants.SUCCESS,
                message: 'You have been sent an email with instructions to reset your password'
            });
            setEmailAddress('');
        })
            .catch(api_1.catchHandler);
    };
    return (react_1.default.createElement("div", { className: 'forgot-password' },
        react_1.default.createElement("form", { className: 'forgot-password__form', onSubmit: submitHandler },
            react_1.default.createElement("h1", null, "Forgotten Password"),
            react_1.default.createElement("p", null, "Enter your email address, you will be sent a link to reset your password"),
            react_1.default.createElement(TextInput_1.default, { type: 'email', name: 'emailAddress', placeholder: 'Email Address', autoFocus: true, value: emailAddress, onChange: function (e) { return setEmailAddress(e.currentTarget.value); } }),
            react_1.default.createElement(Button_1.default, null, "Send"),
            react_1.default.createElement(react_router_dom_1.Link, { to: '/login', title: 'Login' }, "Return to login"))));
};
exports.default = ForgotPassword;
